import React, { useEffect } from 'react';
import { SponsorManager } from './SponsorManager';
import { useData } from '../../../data-layer';

export function Sponsors(): JSX.Element {
  const { sponsors } = useData();

  useEffect(() => {
    sponsors.hook.getAll();
  }, []);

  return <SponsorManager />;
}
